function formatUrl(url = '') {
  if(url.startsWith('http')) {
    return url
  } else {
    return `http://testimage.2828car.com/${url}`
  }
}

export default formatUrl